import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import BrandsApi from '../../../API/provider/brands-api';
import { NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { MARKETS_FILTER_DEFAULT, TYPE_BUTTONS } from '../../../constans';
import StopBrandsLine from './Line';
import styles from './styles.module.scss';

const FILTER = {
  0: 'all',
  1: 'stop_brand',
  2: 'not_stop_brand',
};

export const WIDTH_STOP_BRAND = [
  '40px', //0
  '220px', //1
  '100px', //2
];

const StopBrandsPage = ({ isMinPackage = false, isCityStocks = false, ...props }) => {
  const [search, setSearch] = useState('');
  const [status, changeStatus] = useState('');
  const { role } = useSelector((store) => store.user);

  const [markets, setMarkets] = useState(MARKETS_FILTER_DEFAULT);

  const [show, setShow] = useState(50);

  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);

  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);

  const isAdmin = role === 'owner' || role === 'admin';

  const onChangeTab = (n) => {
    setTab(n);
    setCheckAll(false);
    setProductsSelect({});
  };

  const changeProductSelect = (id) => {
    console.log(id);
    if (productsSelect[id]) {
      const s = productsSelect;
      delete s[id];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [id]: true });
    }
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      ids.forEach((item) => {
        map_select[byId[item]._id] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setProductsSelect({});
    }
  };

  const params = useMemo(() => {
    return {
      search: search.trim(),
      limit: parseInt(show),
      tab: FILTER[tab],
    };
  }, [search, show, tab]);

  const load = async () => {
    await BrandsApi.getBrands({ data: params })
      .then((r) => {
        const byIds = {};
        const id = r.brands.map((item) => item._id);

        r.brands.forEach((item) => (byIds[item._id] = item));

        setById(byIds);
        setIds(id);

        setCount(r.count);
        setCountStock([r.tabs.all, r.tabs.stop_brand, r.tabs.not_stop_brand]);
      });
  };

  const onChange = async (name, field, value) => {
    await BrandsApi.changeBrand({ data: { name, field, value } }).then((r) => setById({ ...byId, [r.brand._id]: r.brand }));
  };

  useEffect(() => {
    load();
  }, [params]);

  return (
    <Content>
      <H1>Стоп бренды</H1>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все бренды', 'Стоп бренды', 'Не стоп бренды']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <Row>
                <div className={styles.t_select}>Выбрано товаров: {`${Object.keys(productsSelect).length}`}</div>
                <Button
                  type={TYPE_BUTTONS.RED}
                  style={{ marginLeft: '15px', marginRight: '15px' }}
                  onClick={() => {
                    setCheckAll(false);
                    setProductsSelect({});
                  }}
                >
                  Очистить выбор
                </Button>
              </Row>
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row>
            <Select
              label="Показать на странице"
              select={show}
              list={['50', '100', '150', '200', '500', '1000']}
              onSelect={(v) => setShow(v)}
              width="150px"
              style={{ marginRight: '20px' }}
            />
          </Row>
        </Row>
      </WhiteBlock>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          {/*   <HeaderTitle width={WIDTH_STOP_BRAND[0]}>
            <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
          </HeaderTitle> */}
          <HeaderTitle width={WIDTH_STOP_BRAND[1]} centerText>
            Наименование бренда
          </HeaderTitle>
          <HeaderTitle width={WIDTH_STOP_BRAND[2]} centerText>
            Стоп бренд Ozon
          </HeaderTitle>
          <HeaderTitle width={WIDTH_STOP_BRAND[2]} centerText>
            Стоп бренд Wb
          </HeaderTitle>
          <HeaderTitle width={WIDTH_STOP_BRAND[2]} centerText>
            Стоп бренд Яндекс
          </HeaderTitle>
        </TableHeader>

        {ids.map((id) => {
          const item = byId[id];

          return (
            <StopBrandsLine
              key={id}
              item={item}
              productsSelect={productsSelect}
              changeProductSelect={changeProductSelect}
              onChange={onChange}
            />
          );
        })}
      </Table>
    </Content>
  );
};

export default StopBrandsPage;
